export default [
    /^(?=.*[a-z])(?=.*\d)[A-Za-z\d@$!%*?&]{10,}$/,
    'Le mot de passe doit contenir au moins 10 caractères dont un chiffre. Caractéres speciaux et majuscules recommendés'
] as [RegExp, string];
